
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
require('typeface-open-sans');

import 'lazysizes';
import './acc';
import './slider';
import './form';
import './navigation';

import initIframeSrcSwap from './map';

/**
 * Init google-maps-iframe-swap
 */
if (document.getElementById('map-iframe')){
  initIframeSrcSwap(document.getElementById('map-iframe'), document.getElementById('map-toggle'), document.getElementById('hint'));
}

import MicroModal from 'micromodal';
MicroModal.init();

const modalCloseButtonsWithData = document.querySelectorAll('[data-custom-close]');

for (let button = 0; button < modalCloseButtonsWithData.length; button++) {
  modalCloseButtonsWithData[button].addEventListener('click', function () {
   const modalToClose = this.getAttribute('data-custom-close');
    MicroModal.close(modalToClose);
  });
}


var teamButtons = document.getElementsByClassName("team-button");

var toggleModal = function() {
  MicroModal.close(this.getAttribute("data-itself-modal"));
  MicroModal.show(this.getAttribute("data-other-modal"));
};

for (var i = 0; i < teamButtons.length; i++) {
  teamButtons[i].addEventListener('click', toggleModal, false);
}
